import { Footer as FooterType } from '../../models/interfaces/Footer.interface.ts'
import { MegaMenu as MegaMenuType } from '../../models/interfaces/MegaMenu.interface.ts'
import Footer from './Footer/Footer.tsx'
import MegaMenu from './MegaMenu/MegaMenu.tsx'
import React, { ReactNode } from 'react'

type LayoutProps = {
    children: ReactNode
    megaMenu: MegaMenuType
    footer: FooterType
    isHomepage?: boolean
}

const Layout = ({ children, megaMenu, footer, isHomepage = false }: LayoutProps) => {
  return (
    <div>
      <MegaMenu {...{ megaMenu, isHomepage }} />
      <main id='main-page' className='content'>
        {children}
      </main>
      <Footer {...{ footer }} />
      <style jsx>{`
        .content {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  )
}

export default Layout
